import { render } from "./ASelect.vue?vue&type=template&id=06990d32"
import script from "./ASelect.vue?vue&type=script&lang=js"
export * from "./ASelect.vue?vue&type=script&lang=js"

import "./ASelect.vue?vue&type=style&index=0&id=06990d32&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__